export const moneyMaskWithoutDecimal = 'separator';
